import { memo, useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useClickAway } from 'react-use';
import { getRequest } from '../../../utils/axiosRequests';
import CommonButtonWithInput from './commonButtonWithInput';

const GyneExamination = ({
  gyneExamination,
  handleOnExaminationData,
  selectedOnExamination,
  setSelectedOnExamination,
}) => {
  const weekButtonArray = ['', 12, 16, 20, 24, 28, 32, 36, 40];
  const uterusButtonArray = ['', 6, 8, 10, 12, 14, 16, 18, 20];
  const [isSfh, setIsSfh] = useState(false);
  const [isFm, setIsFm] = useState(false);
  const [isWeekButton, setIsWeekButton] = useState(false);
  const [isUterusWeekButton, setIsUterusWeekButton] = useState(false);

  const [options, setOptions] = useState([
    {
      name: gyneExamination?.presentation,
      value: gyneExamination?.presentation,
    },
  ]);
  const [searchKey, setSearchKey] = useState('');

  let selectedData = gyneExamination || {
    sfh: '',
    fm: '',
    fhsPresent: false,
    fhsAbsent: false,
    presentation: '',
    nad: false,
    nadNote: '',
    uterus: '',
    wkSize: '',
    os: '',
    cervix: '',
    dischargeYes: false,
    dischargeNo: false,
    effacement: '',
    station: '',
    mumbrance: '',
    showPresent: false,
    showAbsent: false,
    inspectionNad: false,
    lump: '',
    pseCervix: '',
    bmeUterus: '',
    bmeWkSize: '',
    fornix: '',
    cmtPresent: false,
    cmtAbsent: false,
    bleedingAbsent: false,
    bleedingPresent: false,
    pawHealthy: false,
    pawInfected: false,
    paeNote: '',
  };

  const clearData = (itemName) => {
    switch (itemName) {
      case 'fm':
        gyneExamination.fm = '';
        break;
      case 'fhs':
        gyneExamination.fhsPresent = false;
        gyneExamination.fhsAbsent = false;
        break;
      case 'show':
        selectedData['showPresent'] = false;
        selectedData['showAbsent'] = false;
        break;
      case 'cmt':
        selectedData['cmtPresent'] = false;
        selectedData['cmtAbsent'] = false;
        break;
      case 'discharge':
        selectedData['dischargeYes'] = false;
        selectedData['dischargeNo'] = false;
        break;
      case 'paw':
        selectedData['pawHealthy'] = false;
        selectedData['pawInfected'] = false;
        break;
      case 'bleeding':
        selectedData['bleedingAbsent'] = false;
        selectedData['bleedingPresent'] = false;
        break;
      default:
    }
    handleOnExaminationData(gyneExamination, 'gyneExamination');
  };

  const handleData = (rowName, ColName, val, valAnother, isTyping) => {
    const updatedData = { ...selectedData };

    switch (rowName) {
      case 'nadNote':
      case 'inspectionNadNote':
      case 'pawNote':
        updatedData[rowName] = valAnother;
        break;
      case 'sfh':
      case 'fm':
      case 'uterus':
      case 'bmeUterus':
        if (!isTyping) {
          setIsSfh(false);
          setIsFm(false);
          setIsUterusWeekButton(false);
          setIsWeekButton(false);
        }
        updatedData[rowName] = valAnother;
        break;
      case 'fhsPresent':
        updatedData['fhsAbsent'] = false;
        updatedData[rowName] = val;
        break;
      case 'fhsAbsent':
        updatedData['fhsPresent'] = false;
        updatedData[rowName] = val;
        break;
      case 'showPresent':
        updatedData['showAbsent'] = false;
        updatedData[rowName] = val;
        break;
      case 'showAbsent':
        updatedData['showPresent'] = false;
        updatedData[rowName] = val;
        break;
      case 'dischargeYes':
        updatedData['dischargeNo'] = false;
        updatedData[rowName] = val;
        break;
      case 'dischargeNo':
        updatedData['dischargeYes'] = false;
        updatedData[rowName] = val;
        break;
      case 'cmtPresent':
        updatedData['cmtAbsent'] = false;
        updatedData[rowName] = val;
        break;
      case 'pawHealthy':
        updatedData['pawInfected'] = false;
        updatedData[rowName] = val;
        break;
      case 'pawInfected':
        updatedData['pawHealthy'] = false;
        updatedData[rowName] = val;
        break;
      case 'cmtAbsent':
        updatedData['cmtPresent'] = false;
        updatedData[rowName] = val;
        break;
      default:
        updatedData[rowName] = val;
    }

    handleOnExaminationData(updatedData, 'gyneExamination');
    //selectedOnExamination.gyneExamination = selectedData;
    //setSelectedOnExamination({ ...selectedOnExamination });
  };

  const refSfh = useRef(null);
  useClickAway(refSfh, (e) => {
    setIsSfh(false);
  });

  const refFm = useRef(null);
  useClickAway(refFm, (e) => {
    setIsFm(false);
  });

  const refUterus = useRef(null);
  useClickAway(refUterus, (e) => {
    setIsUterusWeekButton(false);
  });

  const refBmeUterus = useRef(null);
  useClickAway(refBmeUterus, (e) => {
    setIsWeekButton(false);
  });

  const getSearchData = async () => {
    try {
      const res = await getRequest(
        `prescriptions/search-gyne-items?searchKey=${searchKey}`,
      );
      console.log(res, 'data');
      setOptions(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (searchKey) {
      getSearchData();
    } else {
      setOptions([]);
    }
  }, [searchKey]);

  const selectedSearchData = (selectedOption) => {
    if (selectedOption?.length) {
      const { name: selectedData, customOption: isNewOption } =
        selectedOption[0];
      if (isNewOption) {
        handleData('presentation', '', selectedData);
        setOptions([...options, { name: selectedData, value: selectedData }]);
      } else {
        handleData('presentation', '', selectedData);
      }
    }
  };

  return (
    <div className="gyne-examination">
      <div className="title-gyne-examination">P/A/E (Pregnency)</div>
      <hr className="hr" />
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>
          <Form.Label>SFH:</Form.Label>
        </Col>
        <Col md={1} ref={refSfh} className="pr-0">
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedData?.sfh ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsSfh(isSfh ? false : true);
            }}
          >
            {selectedData?.sfh ? (
              <span>{selectedData?.sfh}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '17px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          {isSfh && (
            <CommonButtonWithInput
              unitArray={weekButtonArray}
              clickAction={handleData}
              rowName="sfh"
              colName="os"
              indexName="gyne-common-btn"
            />
          )}
        </Col>
        {/* <Col md={1} ref={refSfh} className="pl-0">
          {isSfh && (
            <CommonButtonWithInput
              unitArray={weekButtonArray}
              clickAction={handleData}
              rowName="sfh"
              colName="os"
              indexName="gyne-common-btn"
            />
          )}
        </Col> */}
        <Col md={1} className="pl-0">
          Weeks
        </Col>
      </Form.Group>
      <Form.Group as={Row} className={'pb-2'}>
        <Col md={2}>
          <Form.Label>FM:</Form.Label>
        </Col>
        <Col md={3} ref={refFm} className="pr-0">
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedData?.fm ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsFm(isFm ? false : true);
            }}
          >
            {selectedData?.fm ? (
              <span>{selectedData?.fm}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '16px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          {isFm && (
            <CommonButtonWithInput
              unitArray={['', '+', '-', 'Less Fetal Movement']}
              clickAction={handleData}
              rowName="fm"
              colName="fm"
              indexName="fm-btn"
            />
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Col md={2}>
          <Form.Label>FHS:</Form.Label>
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`fhsPresent`}
            label={`Present`}
            checked={gyneExamination?.fhsPresent === true}
            onChange={(e) => handleData('fhsPresent', '', e.target.checked)}
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`fhsAbsent`}
            label={`Absent`}
            checked={gyneExamination?.fhsAbsent === true}
            onChange={(e) => handleData('fhsAbsent', '', e.target.checked)}
          />
        </Col>
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('fhs')}
          >
            Clear
          </Button>
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Col md={2}>
          <Form.Label>Presentation:</Form.Label>
        </Col>
        <Col md={4} className="gyne-search-item" style={{ position: 'relative' }}>
          <i
            className="fa fa-search"
            style={{
              position: 'absolute',
              zIndex: 2,
              left: '20px',
              top: '8px',
            }}
          />
          <Typeahead
            clearButton
            allowNew
            size="sm"
            id="gyne-search-field"
            defaultSelected={
              gyneExamination?.presentation
                ? [
                    {
                      name: gyneExamination.presentation,
                      value: gyneExamination.presentation,
                    },
                  ]
                : []
            }
            labelKey="name"
            onInputChange={(val) => setSearchKey(val)}
            options={options}
            onChange={(selected) => {
              if (selected.length === 0) {
                handleData('presentation', '', '');
              } else {
                selectedSearchData(selected);
              }
            }}
            placeholder="Choose one..."
          />
        </Col>
      </Form.Group>

      <div className="title-gyne-examination">P/V/E (Pregnency)</div>
      <hr className="hr" />
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>OS:</Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.os}
            onChange={(e) => handleData('os', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>Cervix:</Col>
        <Col md={4}>
          <Form.Control
            type="text"
            size="sm"
            placeholder="Add cervix"
            defaultValue={selectedData?.cervix}
            onChange={(e) => handleData('cervix', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>Effacement:</Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.effacement}
            onChange={(e) => handleData('effacement', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>Station:</Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.station}
            onChange={(e) => handleData('station', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>Mumbrance:</Col>
        <Col md={4}>
          <Form.Control
            type="text"
            size="sm"
            placeholder="Add mumbrance"
            defaultValue={selectedData?.mumbrance}
            onChange={(e) => handleData('mumbrance', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>
          <Form.Label>Show:</Form.Label>
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`showPresent`}
            label={`Present`}
            checked={gyneExamination?.showPresent === true}
            onChange={(e) => handleData('showPresent', '', e.target.checked)}
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`showAbsent`}
            label={`Absent`}
            checked={gyneExamination?.showAbsent === true}
            onChange={(e) => handleData('showAbsent', '', e.target.checked)}
          />
        </Col>
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('show')}
          >
            Clear
          </Button>
        </Col>
      </Form.Group>

      <div className="title-gyne-examination">P/A/E (Gynae)</div>
      <hr className="hr" />
      <Form.Group as={Row}>
        <Col md={2}>
          <Form.Label>NAD:</Form.Label>
        </Col>
        <Col md={4}>
          <Form.Check
            type={`checkbox`}
            id={`nad`}
            label={``}
            checked={selectedData?.nad === true}
            onChange={(e) => handleData('nad', '', e.target.checked)}
          />
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.nadNote}
            value={selectedData?.nadNote}
            onChange={(e) => handleData('nadNote', '', '', e.target.value)}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="pb-2 mt-3">
        <Col md={2}>
          <Form.Label>Uterus:</Form.Label>
        </Col>
        <Col md={1} className="pr-0">
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedData?.uterus ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsUterusWeekButton(isUterusWeekButton ? false : true);
            }}
          >
            {selectedData?.uterus ? (
              <span>{selectedData?.uterus}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '17px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
        </Col>
        <Col md={4} className="pl-0" ref={refUterus}>
          {isUterusWeekButton && (
            <CommonButtonWithInput
              unitArray={uterusButtonArray}
              clickAction={handleData}
              rowName="uterus"
              colName="os"
              indexName="gyne-common-btn"
            />
          )}
        </Col>
        <Col md={2} className="text-right">
          Size
        </Col>
        <Col md={3}>
          <Form.Control
            type="text"
            size="sm"
            placeholder="Add size"
            defaultValue={selectedData?.wkSize}
            onChange={(e) => handleData('wkSize', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Col md={2}>LUMP:</Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add lump"
            defaultValue={selectedData?.lump}
            onChange={(e) => handleData('lump', '', e.target.value)}
          />
        </Col>
      </Form.Group>

      <div className="title-gyne-examination">P/V/E (Gynae)</div>
      <hr className="hr" />
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>Inspection:</Col>
        <Col md={4}>
          <Form.Check
            type={`checkbox`}
            id={`inspection`}
            label={`NAD`}
            checked={selectedData?.inspectionNad === true}
            onChange={(e) => handleData('inspectionNad', '', e.target.checked)}
          />
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.inspectionNadNote}
            value={selectedData?.inspectionNadNote}
            onChange={(e) =>
              handleData('inspectionNadNote', '', '', e.target.value)
            }
          />
        </Col>
      </Form.Group>
      <div className="title-gyne-examination">
        Per Speculum Examination (P/S/E):
      </div>
      <hr className="hr" />
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>Cervix:</Col>
        <Col md={6}>
          <Form.Control
            size="sm"
            type="text"
            placeholder="Add cervix"
            defaultValue={selectedData?.pseCervix}
            onChange={(e) => handleData('pseCervix', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Col md={2}>
          <Form.Label>Discharge:</Form.Label>
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`dischargeYes`}
            label={`Yes`}
            checked={gyneExamination?.dischargeYes === true}
            onChange={(e) => handleData('dischargeYes', '', e.target.checked)}
          />
        </Col>
        <Col md={1}>
          <Form.Check
            type={`radio`}
            id={`dischargeNo`}
            label={`No`}
            checked={gyneExamination?.dischargeNo === true}
            onChange={(e) => handleData('dischargeNo', '', e.target.checked)}
          />
        </Col>
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('discharge')}
          >
            Clear
          </Button>
        </Col>
        <Col></Col>
        <Col md={5}>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add note"
            defaultValue={selectedData?.dischargeNote}
            onChange={(e) => handleData('dischargeNote', '', e.target.value)}
          />
        </Col>
      </Form.Group>

      <div className="title-gyne-examination">
        Bimanual Examination (B/M/E):
      </div>
      <hr className="hr" />
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>
          <Form.Label>Uterus:</Form.Label>
        </Col>
        <Col md={1} className="pr-0">
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedData?.bmeUterus ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => setIsWeekButton(isWeekButton ? false : true)}
          >
            {selectedData?.bmeUterus ? (
              <span>{selectedData?.bmeUterus}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '17px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
        </Col>
        <Col className="pl-0" ref={refBmeUterus}>
          {isWeekButton && (
            <CommonButtonWithInput
              unitArray={uterusButtonArray}
              clickAction={handleData}
              rowName="bmeUterus"
              colName="os"
              indexName="gyne-common-btn"
            />
          )}
        </Col>
        <Col className="text-right">Size</Col>
        <Col sm="4">
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add size"
            defaultValue={selectedData?.bmeWkSize}
            onChange={(e) => handleData('bmeWkSize', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col sm="2">
          <Form.Label>Fornices:</Form.Label>
        </Col>
        <Col sm="6">
          <Form.Control
            size="sm"
            type="text"
            placeholder="Add fornices"
            defaultValue={selectedData?.fornix}
            onChange={(e) => handleData('fornix', '', e.target.value)}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>
          <Form.Label>CMT:</Form.Label>
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`cmtPresent`}
            label={`Present`}
            checked={gyneExamination?.cmtPresent === true}
            onChange={(e) => handleData('cmtPresent', '', e.target.checked)}
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`cmtAbsent`}
            label={`Absent`}
            checked={gyneExamination?.cmtAbsent === true}
            onChange={(e) => handleData('cmtAbsent', '', e.target.checked)}
          />
        </Col>
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('cmt')}
          >
            Clear
          </Button>
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>
          <Form.Label>Bleeding:</Form.Label>
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`bleedingPresent`}
            label={`Present`}
            checked={gyneExamination?.bleedingPresent === true}
            onChange={(e) =>
              handleData('bleedingPresent', '', e.target.checked)
            }
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`bleedingAbsent`}
            label={`Absent`}
            checked={gyneExamination?.bleedingAbsent === true}
            onChange={(e) => handleData('bleedingAbsent', '', e.target.checked)}
          />
        </Col>
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('bleeding')}
          >
            Clear
          </Button>
        </Col>
      </Form.Group>

      <div className="title-gyne-examination">Per Abdominal Wound:</div>
      <hr className="hr" />
      <Form.Group as={Row} className="pb-2">
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`healthy`}
            label={`Healthy`}
            checked={gyneExamination?.pawHealthy === true}
            onChange={(e) => handleData('pawHealthy', '', e.target.checked)}
          />
        </Col>
        <Col md={2} className="pr-0">
          <Form.Check
            type={`radio`}
            id={`infected`}
            label={`Infected`}
            checked={gyneExamination?.pawInfected === true}
            onChange={(e) => handleData('pawInfected', '', e.target.checked)}
          />
        </Col>
        <Col md={1} className="pl-0">
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('paw')}
          >
            Clear
          </Button>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.pawNote}
            value={selectedData?.pawNote}
            onChange={(e) => handleData('pawNote', '', '', e.target.value)}
          />
        </Col>
      </Form.Group>
    </div>
  );
};

export default memo(GyneExamination);
